/**
 * @generated SignedSource<<02d1a5ae9f2cccb978ad7f1c86950f7f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routes_VehicleParkMap_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VehicleParking",
        "kind": "LinkedField",
        "name": "vehicleParking",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VehicleParkMapContainer_vehiclePark"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "routes_VehicleParkMap_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VehicleParking",
        "kind": "LinkedField",
        "name": "vehicleParking",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vehicleParkingId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lat",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lon",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b40f0c519fbcad5d501b05614563d549",
    "id": null,
    "metadata": {},
    "name": "routes_VehicleParkMap_Query",
    "operationKind": "query",
    "text": "query routes_VehicleParkMap_Query(\n  $id: String!\n) {\n  vehicleParking(id: $id) {\n    ...VehicleParkMapContainer_vehiclePark\n    id\n  }\n}\n\nfragment VehicleParkMapContainer_vehiclePark on VehicleParking {\n  vehicleParkingId\n  lat\n  lon\n  name\n}\n"
  }
};
})();

node.hash = "6a6faa48e56d948d4a76d557d1604b40";

module.exports = node;
